export default function initResultsCounterProducts() {
    // TRAVA DE SEGURANÇA: Só executa este script na página de categorias de produtos
    if (!document.body.classList.contains('tax-categoria-produto')) {
        return;
    }
    return;
}